import React from 'react';
import { Menu } from 'antd';
import { SettingOutlined, ToolOutlined, RiseOutlined } from '@ant-design/icons';
import logo from '../../images/logo.png';


const { SubMenu } = Menu;


function SecondaryNavbar({ mode }) {
  return (
    <div className="">
        <Menu mode={mode}>
            {/* <Menu.Item key="mail" icon={<MailOutlined />}>
                Navigation One
            </Menu.Item>*/}
            {mode === "inline" && (
                <Menu.Item key="home" style={{height: "auto", marginBottom: "1rem", width: "15rem"}}>
                    <div className="flex justify-center">
                        <img className="h-16 my-2 -ml-4" src={logo} alt="TractorSingh Logo"/>
                    </div>
                </Menu.Item>)
            }
            <SubMenu title={
                <>
                    <RiseOutlined style={{display: "inline-flex", paddingLeft: "5px"}}/>
                    Top Brands 
                    {mode === "inline" && <span className="mr-4"></span>}
                </>
                }>
                <Menu.Item key="Mahindra">Mahindra</Menu.Item>
                <Menu.Item key="John Deere">John Deere</Menu.Item>
                <Menu.Item key="Eicher">Eicher</Menu.Item>
                <Menu.Item key="Sonalika">Sonalika</Menu.Item>
                <Menu.Item key="Escort">Escort</Menu.Item>
            </SubMenu>
            <SubMenu title={
                <>
                    <SettingOutlined style={{display: "inline-flex", paddingLeft: "5px"}}/>
                    Tractors 
                    {mode === "inline" && <span className="mr-4"></span>}
                </>
            }>
                <Menu.Item key="Popular Tractors">Popular Tractors</Menu.Item>
                <Menu.Item key="Recommended Tractor">Recommended Tractor</Menu.Item>
                <Menu.Item key="Latest tractor">Latest Tractor</Menu.Item>
                <Menu.Item key="Upcoming Tractor">Upcoming Tractor</Menu.Item>
                <Menu.Item key="Mini Tractor">Mini Tractor</Menu.Item>
                <Menu.Item key="Electric Tractor">Electric Tractor</Menu.Item>
            </SubMenu>
            <Menu.Item key="Implements">
                <ToolOutlined style={{display: "inline-flex", paddingLeft: "5px"}}/>
                Implements 
                {mode === "inline" && <span className="mr-4"></span>}
            </Menu.Item>
            {/* <Menu.Item key="Harvestors">Harvestors</Menu.Item> */}
            <Menu.Item key="Tools">
                <ToolOutlined style={{display: "inline-flex", paddingLeft: "5px"}}/>
                Tools
                {mode === "inline" && <span className="mr-4"></span>}
            </Menu.Item>
            <Menu.Item key="Agricultural news" disabled>
                Agricultural news 
                {/* <ClockCircleOutlined style={{display: "inline-flex", paddingLeft: "5px"}}/> */}
                {mode === "inline" && <span className="mr-4"></span>}
            </Menu.Item>
            <Menu.Item key="Latest updates" disabled>
                Latest updates
                {/* <ClockCircleOutlined style={{display: "inline-flex", paddingLeft: "5px"}}/> */}
                {mode === "inline" && <span className="mr-4"></span>}
            </Menu.Item>
            <Menu.Item key="Tractor news" disabled>
                Tractor news
                {/* <ClockCircleOutlined style={{display: "inline-flex", paddingLeft: "5px"}}/> */}
                {mode === "inline" && <span className="mr-4"></span>}
            </Menu.Item>
            <Menu.Item key="Insurance" disabled>
                Insurance
                {/* <ClockCircleOutlined style={{display: "inline-flex", paddingLeft: "5px"}}/> */}
                {mode === "inline" && <span className="mr-4"></span>}
            </Menu.Item>
            <Menu.Item key="Loan" disabled>
                Loan
                {/* <ClockCircleOutlined style={{display: "inline-flex", paddingLeft: "5px"}}/> */}
                {mode === "inline" && <span className="mr-4"></span>}
            </Menu.Item>
            <Menu.Item key="Offers" disabled>
                Offers
                {/* <ClockCircleOutlined style={{display: "inline-flex", paddingLeft: "5px"}}/> */}
                {mode === "inline" && <span className="mr-4"></span>}
            </Menu.Item>
            <Menu.Item key="Delalership Enquiry" disabled>
                Delalership Enquiry
                {/* <ClockCircleOutlined style={{display: "inline-flex", paddingLeft: "5px"}}/> */}
                {mode === "inline" && <span className="mr-4"></span>}
            </Menu.Item>
        </Menu>
    </div>
  );
}

export default SecondaryNavbar;
